module.exports = __webpack_public_path__ + "img/die-2.1318fbd4.png";